<script>
  import Image from '$lib/Image.svelte'

  /** @type {string?} */
  export let date = null

  /** @type {string?} */
  export let author = null

  /** @type {import('@prismicio/types').ImageField<'mobile', 'filled'>} */
  export let portrait
</script>

<div class="meta">
  {#if author}
    <div class="author">
      <div class="label">Written by</div>
      {#if portrait}
        <div class="image">
          <Image
            src={portrait?.url}
            alt={portrait?.alt || `Portrait of ${author}`}
            sizes="2rem"
            variants={[36, 72, 108]}
            aspect={1}
            width="100"
            height="100" />
        </div>
      {/if}
      <strong>{author}</strong>
    </div>
  {/if}
  <div class="date">
    {#if date}
      <div class="label">Published on</div>
      <time datetime={date}>
        {new Date(date).toLocaleDateString('en', {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        })}
      </time>
    {/if}
  </div>
</div>

<style>
  .meta {
    display: flex;
    gap: 2rem;
    justify-content: space-between;
    align-items: flex-start;
    max-width: var(--current-max-width, 25rem);
    font-weight: 600;
    white-space: nowrap;
    padding-right: 2rem;
  }

  .author {
    display: flex;
    align-items: center;
    gap: 0 0.5rem;
    flex-wrap: wrap;
  }

  .image {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    margin: -2rem 0;
    overflow: hidden;
    box-shadow: var(--box-shadow-sm);
    background: rgb(var(--rgb-light-gray));
  }

  .label {
    width: 100%;
    color: rgb(var(--rgb-muted));
    margin-bottom: 0.25rem;
    font-weight: normal;
  }

  .meta :global(:has(img) .label) {
    margin-bottom: 0.75rem;
  }
</style>
